export default __webpack_public_path__ + "static/palette-jira-board-light-d4709088fc09407d7509f903c47add614a6c944a780af6787c33afecd11dd120.png";